import Vue from 'vue'
export default {
    // 修改订单页筛选项条件=>供订单详情页的前进后退
    setOrderDetailParams(state,data){
        state.orderDetailParams = data;
    },
    // 修改订单页筛选项条件的页数=>供订单详情页的前进后退
    setOrderDetailParamsP(state,data){
        state.orderDetailParams.p = data;
    },
}
